import { Injectable, inject } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AsesorStore, AsesorApiResponse } from './codigo-asesor.store';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface AsesorApiWrapper {
  status: boolean;
  codeStatus: string;
  message: string;
  data: AsesorApiResponse[];
  errorMessage: string;
}

@Injectable({ providedIn: 'root' })
export class AsesorService {
  private http = inject(HttpClient);
  private store: AsesorStore = inject(AsesorStore);

  private readonly URL = `${ENV.HOST}${URL_MAP.API.COTIZADOR_CODIGO_ASESOR}`;

  getAsesorPorDocumento(numeroDocumento: string) {
    this.store.loading.set(true);

    const body = {
      nombreClave: 'getSpAsesorDocumento',
      jsonParametros: JSON.stringify({
        prm_docu_asesor: numeroDocumento,
      }),
    };

    this.http
      .post<AsesorApiWrapper>(this.URL, body)
      .pipe(
        tap((resp) => {
          if (resp.status && resp.data?.length) {
            this.store.setAsesor(resp.data[0]);
          } else {
            this.store.clearAsesor();
          }
        }),
        catchError(() => {
          this.store.clearAsesor();
          return of(null);
        }),
        tap(() => this.store.loading.set(false))
      )
      .subscribe();
  }
}
